/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="f7217e6f-59bf-4c11-aa1d-06f5a4dda6a0" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="e8ce99d0-98fb-477a-ac96-4078045f2e48" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
            <g id="abb141f3-2157-4d95-9f00-7868f0fcc4ce">
              <path id="ffbaea75-b244-4e2b-b257-6ee76db1139a" d="M21,12.05a9,9,0,1,0-9,9A9,9,0,0,0,21,12.05Zm-9,8a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm-1.65-9.15c-.31.48-1,1.77-2.89,5.4l-.73,1.38,1.5-.8c3.51-1.82,4.82-2.5,5.29-2.8l.26-.13,3.79-7.09-7.09,3.81Zm4.88-1.7L13.31,12.8c-.47-.47-1.21-1.2-1.68-1.68Zm-2.61,4.28L9.06,15.36,11,11.8l1.68,1.67Z" fill="#fff" style={{ fillRule: 'evenodd' }}/>
            </g>
          </mask>
        </defs>
        <g id="f91df9a3-65c3-4f77-89d8-7ead8c9c9019">
          <g id="b2c7d86f-b9cd-4ddd-b801-f9367afc53d3">
            <g id="f7707b92-963a-48aa-b971-b073cd4a2cbf">
              <path id="fe5192de-51c6-478d-9714-7e1278dd692e" d="M21,12.05a9,9,0,1,0-9,9A9,9,0,0,0,21,12.05Zm-9,8a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm-1.65-9.15c-.31.48-1,1.77-2.89,5.4l-.73,1.38,1.5-.8c3.51-1.82,4.82-2.5,5.29-2.8l.26-.13,3.79-7.09-7.09,3.81Zm4.88-1.7L13.31,12.8c-.47-.47-1.21-1.2-1.68-1.68Zm-2.61,4.28L9.06,15.36,11,11.8l1.68,1.67Z" fill="#05273e" className="icon-fill"/>
            </g>
            <g style={{ mask: 'url(#e8ce99d0-98fb-477a-ac96-4078045f2e48)' }}>
              <g id="a4c11761-067c-48dc-a65a-46e99a0fefc7">
                <rect id="a132ee13-8442-43d8-bf36-a4c61026cb51" width="24" height="24" fill="#002b49" className="icon-fill"/>
              </g>
            </g>
            <g style={{ mask: 'url(#e8ce99d0-98fb-477a-ac96-4078045f2e48)' }}>
              <rect id="a0e782da-ddc4-486c-9024-84de4b3b8c3b" width="24" height="24" className="icon-fill"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'CompassIcon';

export default Icon;
